document.querySelectorAll('.collection-description .readmore').forEach(function(element) {
    element.addEventListener('click', function(event) {
        event.preventDefault();
        var descriptionFull = document.querySelector('.collection-description-full');
        descriptionFull.style.display = 'block';
        var descriptionShort = document.querySelector('.collection-description-short');
        descriptionShort.style.display = 'none';
    });
});

document.querySelectorAll('.collection-description .readless').forEach(function(element) {
    element.addEventListener('click', function(event) {
        event.preventDefault();
        var descriptionFull = document.querySelector('.collection-description-full');
        descriptionFull.style.display = 'none';
        var descriptionShort = document.querySelector('.collection-description-short');
        descriptionShort.style.display = 'block';
    });
});